import formElements from './components/form-elements';

export default () => {
  formElements();
};
